<template>
    <div :class="$style.product_wrap">
      <nuxt-link :class="$style.product" :to="buildProductDetailLink(product) " :title="product.name" target="_blank">
            <v-responsive :aspect-ratio="310 / 192" class="relative">
                <div :class="$style.product_cover">
                    <el-image :class="$style.product_img" :src="product.image" />
                </div>
                <div v-if="!isShow && loggedIn" class="absolute top-[8px] right-[8px]">
                  <el-image
                    class="w-[40px] cursor-pointer"
                    v-if="!!isFavorite"
                    fit="cover"
                    :src="require('@/assets/img/resource/collected-icon.png')"
                    @click.stop.prevent="clickFavorite"
                  />
                  <el-image
                    class="w-[40px] cursor-pointer"
                    v-else
                    fit="cover"
                    :src="require('@/assets/img/resource/collect-icon.png')"
                    @click.stop.prevent="clickFavorite"
                  />
              </div>
            </v-responsive>
            <div :class="$style.product_content">
                <div :class="$style.product_name" >{{ product.name }}</div>
                <div :class="$style.product_footer">
                    <div v-if="rank <= 3 & isShow" :class="$style.tag">
                        <div :class="$style.tag_label">优惠</div>
                        <div :class="$style.tag_value">TOP{{ rank }}</div>
                    </div>
                    <div :class="$style.product_price">
                        <div :class="$style.product_price_sale"><span class="text-base">零售价：</span><b class="text-dark" :style="{color: isShow ? '' : '#cc4b0c'}">￥</b><span
                                class="text-xl text-dark font-medium" :style="{color: isShow ? '' : '#cc4b0c', fontSize: isShow ? '' : '30px'}">{{ product.min_sale_price }}</span> 起/人</div>
                        <div v-if="isDistributor && product.min_th_price" :class="$style.product_price_th"><span class="text-base">同行价：</span><b class="text-price">￥</b><span
                                class="text-3xl text-price font-medium">{{ product.min_th_price }}</span> 起/人</div>
                    </div>
                </div>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
import { defineComponent, useStore, computed, ref } from "@nuxtjs/composition-api";
import VResponsive from "@/components/VResponsive/VResponsive.vue";
import { buildProductDetailLink } from '~/utils/product'

export default defineComponent({
    name: 'DiscountedGoodsCard',
    components: {
        VResponsive
    },
    props: {
        rank: Number,
        product: {
            type: Object,
            default: () => ({
                image: "",
                min_sale_price: "",
                min_th_price: "",
                name: "",
                product_no: "",
                is_tripartite_product: '',
                product_type: '1',
                is_favorite: 0,
            })
        },
        isShow: {
          type: Boolean,
          default: true,
        },
    },
    emits: ['onToggleFavorite'],
    setup(props,{ emit }) {
        const store = useStore();
        const isDistributor = computed(() => store.getters.isDistributor)
        const loggedIn = computed( ()=> store.state.auth.loggedIn)
        const isFavorite = ref(props.product.is_favorite)
        const clickFavorite = () => {
          emit('onToggleFavorite',props.product.is_favorite, props.product.product_no)
          props.product.is_favorite = !props.product.is_favorite
          isFavorite.value = !isFavorite.value
        }
        return {
            buildProductDetailLink,
            isDistributor,
            loggedIn,
            isFavorite,
            clickFavorite
        }
    }
})
</script>

<style lang="scss" module>
.product {
  display: block;
}
.product_wrap {
  border-radius: 0.25rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.product_img, .product_cover {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.product_cover {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.product_img {
  display: block;
  width: 100%;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -webkit-transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-duration: 100ms;
  -o-transition-duration: 100ms;
  transition-duration: 100ms;
}
.product_name {
  font-weight: 500;
  height: 3rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_content {
  padding: 1rem;
  padding-top: 0.75rem;
  position: relative;
  background: linear-gradient(27deg, #FFF8EF 0%, rgba(255, 255, 255, 0) 100%);
}
.product_footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  margin-top: 1rem;
}
.product_price {
  font-size: 0.8125rem;
  line-height: 1.125rem;
  line-height: 1;
  margin-left: auto;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
.product_price_th, .product_price_sale {
  text-align: right;
  white-space: nowrap;
}
.tag {
  background-position: center;
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: 600;
  height: 2rem;
  line-height: 1;
  position: absolute;
  left: 1rem;
  bottom: 1.25rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  width: 2.5rem;
  background-image: url('~@/assets/img/tag-bg.png');
  background-size: 100%;
}
.tag_label {
  font-size: 0.8125rem;
  line-height: 1.125rem;
}
.tag_value {
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: -0.125rem;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-scale-x: 0.83;
  --tw-scale-y: 0.83;
  --tw-scale-z: 0.83;
}
</style>
